import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xs uppercase tracking-wider text-gray-500" }
const _hoisted_2 = { class: "mt-2 text-3xl font-bold text-gray-900" }

import { computed } from 'vue'

import ReportDelta from '@/components/reports/ReportDelta.vue'


export default {
  __name: 'AgentConversationsTile',
  props: {
  label: { type: String, required: true },
  value: { type: String, required: true },
  caption: { type: String, default: '' },
  delta: { type: Number, default: undefined },
  deltaInverted: { type: Boolean, default: false },
  deltaUnit: { type: String, default: 'percent' }, // 'percent' | 'pp'
  // Drops the card chrome so several tiles can sit inside one shared panel.
  flush: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const showDelta = computed(() => props.delta !== undefined)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.flush ? 'p-6' : 'bg-white rounded-lg border border-gray-200 p-6')
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.value), 1),
    (showDelta.value)
      ? (_openBlock(), _createBlock(ReportDelta, {
          key: 0,
          class: "mt-2 block text-sm",
          delta: __props.delta,
          "delta-inverted": __props.deltaInverted,
          "delta-unit": __props.deltaUnit
        }, null, 8, ["delta", "delta-inverted", "delta-unit"]))
      : _createCommentVNode("", true),
    (__props.caption)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["text-sm text-gray-500", showDelta.value ? 'mt-1' : 'mt-2'])
        }, _toDisplayString(__props.caption), 3))
      : _createCommentVNode("", true)
  ], 2))
}
}

}